import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Link, Stack } from '@mui/material';

// assets
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import FeedTwoToneIcon from '@mui/icons-material/FeedTwoTone';

// tab content customize
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box
                    sx={{
                        p: 1
                    }}
                >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

// ================================|| UI TABS - COLOR ||================================ //

export default function ColorTabs() {
    const theme = useTheme();
    return (
        <Stack direction="row" spacing={1}>
            <Button startIcon={<HomeTwoToneIcon />} sx={{ color: theme.palette.main.items }}>
                <RouterLink component={Link} to="pages/homepage" target="_blank">
                    Trang chủ
                </RouterLink>
            </Button>
            <Button startIcon={<FeedTwoToneIcon />} sx={{ color: theme.palette.main.items }}>
                <Link
                    component={Link}
                    sx={{ color: theme.palette.main.items, textDecoration: 'none' }}
                    href="https://chatgpt.youteach.ai/"
                    target="_blank"
                >
                    Blog
                </Link>
            </Button>
        </Stack>
    );
}
